export default "__VITE_ASSET__BXfWY_Bt__"